import { apiClient } from 'config/api';

export type ResolveDecision = 'APPROVED' | 'REJECTED';

/**
 * Approves or rejects a pending dispersion creation
 * @param body - body payload request
 * @param body.id - pending dispersion id
 * @param body.decision - APPROVED or REJECTED
 */
async function postResolvePendingDispersion({
  id,
  decision,
}: {
  id: string;
  decision: ResolveDecision;
}) {
  const url = `/v3/dispersion/pending/${id}/resolve`;
  const response = await apiClient.post(url, { decision });
  return response.data;
}

export default postResolvePendingDispersion;
